import { render, staticRenderFns } from "./StockClosingPrintDetail_Total.vue?vue&type=template&id=396a6795&"
import script from "./StockClosingPrintDetail_Total.vue?vue&type=script&lang=js&"
export * from "./StockClosingPrintDetail_Total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports